import {useFormikContext} from 'formik'
import {FormattedMessage, useIntl} from 'react-intl'
import {ISettingsForm} from '../../../../../../_metronic/helpers/custom/tsHelpers/profileHelpers'
import {SettingsRadio} from '../../../../../modules/custom/form-elements/radios/SettingsRadio'
import {Notification} from '../../../../../modules/custom/Notification'
import {useQuery, useQueryClient} from 'react-query'
import {generalApi} from '../../../../../../_metronic/helpers/custom/api/generalApi'
import {ITariffs} from '../../../../../../_metronic/helpers/custom/tsHelpers/generalHelpers'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useLayout} from '../../../../../../_metronic/layout/core'

const NotificationSettings = () => {
  const intl = useIntl()
  const {setFieldValue, values, errors, touched} = useFormikContext<ISettingsForm>()
  const queryClient = useQueryClient()
  const messagesList: Record<string, string>[] | undefined =
    queryClient.getQueryData('messagesList')
  const {websiteData} = useLayout()

  return (
    <div>
      {/*<span className='form-check-label d-flex flex-column align-items-start mb-5'>*/}
      {/*  <span className='fw-bolder fs-5 '>*/}
      {/*    <FormattedMessage id='PROFILE.PAGE.SETTINGS.NOTIFICATIONS' />*/}
      {/*  </span>*/}
      {/*</span>{' '}*/}
      {/*<div>*/}
      {/*  {' '}*/}
      {/*  <SettingsRadio*/}
      {/*    title={intl.formatMessage({*/}
      {/*      id: 'PROFILE.PAGE.SETTINGS.NOTIFICATIONS.EMAIL_OPTION',*/}
      {/*    })}*/}
      {/*    type='checkbox'*/}
      {/*    inputName='notification_email'*/}
      {/*    formValues={values}*/}
      {/*    value={1}*/}
      {/*    setFieldValue={setFieldValue}*/}
      {/*    checkboxIsChecked={values.notification_email}*/}
      {/*  />*/}
      {/*  <SettingsRadio*/}
      {/*    title={intl.formatMessage({*/}
      {/*      id: 'PROFILE.PAGE.SETTINGS.NOTIFICATIONS.TELEGRAM_OPTION',*/}
      {/*    })}*/}
      {/*    description={*/}
      {/*      <a*/}
      {/*        href='https://t.me/vectorDbot'*/}
      {/*        target='_blank'*/}
      {/*        rel='noreferrer noopener'*/}
      {/*        className='text-muted fw-bold text-hover-muted d-block fs-6 mb-6'*/}
      {/*      >*/}
      {/*        <FormattedMessage id='PROFILE.PAGE.SETTINGS.TELEGRAM.OPEN' />*/}
      {/*      </a>*/}
      {/*    }*/}
      {/*    inputName='notification_bm'*/}
      {/*    formValues={values}*/}
      {/*    value={1}*/}
      {/*    type='checkbox'*/}
      {/*    setFieldValue={setFieldValue}*/}
      {/*    checkboxIsChecked={values.notification_bm}*/}
      {/*  />*/}
      {/*  {errors.notification_bm && touched.notification_bm && (*/}
      {/*    <div className='text-danger'>*/}
      {/*      <FormattedMessage id='PROFILE.PAGE.SETTINGS.NOTIFICATIONS.REQUIRED' />*/}
      {/*    </div>*/}
      {/*  )}*/}
      {/*</div>*/}
      {websiteData.telegramBotName ? (
        <span className='form-check-label d-flex flex-column align-items-start mb-5'>
          <span className='fw-bolder fs-5 '>
            <FormattedMessage id='PROFILE.PAGE.SETTINGS.MESSAGES' defaultMessage='Messages' />
            <a
              href={`https://t.me/${websiteData.telegramBotName}`}
              target='_blank'
              rel='noreferrer noopener'
              className='text-muted fw-bold text-hover-muted d-block fs-6'
            >
              <KTSVG path='/media/svg/brand-logos/telegram-app.svg' className='svg-icon-1 me-1' />
              <FormattedMessage id='PROFILE.PAGE.SETTINGS.TELEGRAM.OPEN' />
            </a>
          </span>
        </span>
      ) : null}
      <div className='table-responsive'>
        <table className='table table-row-bordered table-row-gray-100 w-auto'>
          <thead>
            <tr className='fw-bolder text-muted'>
              <th className='min-w-125px'>
                <FormattedMessage
                  id='PROFILE.PAGE.SETTINGS.MESSAGES.TITLE'
                  defaultMessage='Subject'
                />
              </th>
              <th className='min-w-125px text-center'>
                <FormattedMessage id='PROFILE.PAGE.SETTINGS.NOTIFICATIONS.EMAIL_OPTION' />
              </th>
              <th className='min-w-125px text-center'>
                <FormattedMessage id='PROFILE.PAGE.SETTINGS.NOTIFICATIONS.TELEGRAM_OPTION' />
              </th>
            </tr>
          </thead>
          <tbody>
            {messagesList &&
              Object.keys(messagesList)?.map((message, index) => (
                <tr key={index}>
                  <td>
                    <div className='d-flex align-items-center'>
                      <span className='text-dark fw-bold text-hover-primary fs-6'>
                        {
                          // @ts-ignore
                          messagesList[message]
                        }
                      </span>
                    </div>
                  </td>
                  <td>
                    <SettingsRadio
                      type='checkbox'
                      inputName={`notificationSettings.${message}.email`}
                      formValues={values}
                      value={1}
                      setFieldValue={setFieldValue}
                      checkboxIsChecked={
                        values.notificationSettings
                          ? // @ts-ignore
                            values.notificationSettings[message]?.email
                          : false
                      }
                      labelClassName='justify-content-center'
                    />
                  </td>
                  <td>
                    <SettingsRadio
                      type='checkbox'
                      inputName={`notificationSettings.${message}.telegram`}
                      formValues={values}
                      value={1}
                      setFieldValue={setFieldValue}
                      checkboxIsChecked={
                        values.notificationSettings
                          ? // @ts-ignore
                            values.notificationSettings[message]?.telegram
                          : false
                      }
                      labelClassName='justify-content-center'
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default NotificationSettings
